import React, { useCallback, useContext } from 'react';

import { PregnanciesContextContext } from '../../pregnancies.context';
import DialogPregnanciesForm from '../Form/DialogPregnanciesForm';

export default function EditDialog() {
  const { editDialogOpened, setEditDialogOpened, selectedData, reload } = useContext(PregnanciesContextContext);
  const closeDialog = useCallback(
    (success: boolean) => {
      if (success) {
        reload();
      }
      setEditDialogOpened(false);
    },
    [reload, setEditDialogOpened]
  );

  return <DialogPregnanciesForm open={editDialogOpened} onClose={closeDialog} data={selectedData} />;
}
